import { render, staticRenderFns } from "./ali.vue?vue&type=template&id=2a994f68&scoped=true&"
import script from "./ali.vue?vue&type=script&lang=js&"
export * from "./ali.vue?vue&type=script&lang=js&"
import style0 from "./ali.vue?vue&type=style&index=0&id=2a994f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a994f68",
  null
  
)

export default component.exports